export default {
	methods: 
    {
		// notificacion al guardar
		async saveNotify(error,color,title=false,content=false)
		{
			try{
				if(error) {
					await this.changeGlobal({ state: 'saveConfig/notification/error', boolean: true})
					await this.updateGlobal({ state: 'saveConfig/notification/title', data: 'No se guardaron los datos, intentalo de nuevo'})
				}
				if(content!==false) {
					await this.updateGlobal({ state: 'saveConfig/notification/content', data: content})
				}
				if(title!==false) {
					await this.updateGlobal({ state: 'saveConfig/notification/title', data: title})
				}
				await this.updateGlobal({ state: 'saveConfig/notification/color', data: color})
				await this.changeGlobal({ state: 'saveConfig/notification/view',  boolean: true})
				return !error
			}catch {

			}
		},
		// guardamos información en el backend
		async save(agregar=false) {
			if(typeof agregar === 'boolean')
			{
				( async () => { 
					const dataForm = {}
					for (let i = 0; i < this.dataPost[this.namePath].tablaPost.length; i++) {
						dataForm[this.dataPost[this.namePath].tablaPost[i]]={}
						if(this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]]!==undefined)
						{
							dataForm[this.dataPost[this.namePath].tablaPost[i]]=this.dataForm[this.namePath][this.dataPost[this.namePath].tablaPost[i]]
						}						
					}
					await this.pushDataPost({state: 'data', data: dataForm})
					///estoy buscando el autofocus en el seach de dataPost
					await this.changeGlobal({state: 'saveConfig/autofocus', boolean: true})
				})()
				if(!agregar)
				{
					let promiseValues = await new Promise(async (resolve, reject) => {										
							await this.changeGlobal({state: 'saveConfig/capa', boolean: true})
							//   enviamos datos al backend  
							let promiseValue =  await this.saveAll(this.dataPost[this.namePath]).then( async (response) => {
								// aca lanzamos la notificacion y revisamos si hubo error o no y resolvemos		          
								this.saveNotify(response.data.error.error,this.indexData)		          
								if(response.data.error===false)
								{    			 			         
									if(response.data.lists.length===undefined && typeof response.data.lists === 'object' )
									{					 		
										await this.saveIdb(response.data.lists)
									}			 								
									await this.resetDataPost({state: 'data'}) 
									await this.resetGlobal({state: 'saveConfig/capa'}) 
									await this.resetGlobal({state: 'saveConfig/popoverShow'}) 
									
									return response.data
								}
								return response.data.error						             
							}).catch(
							async (error) => {	          		  
							//   aca manipulamos los datos del store despues del error   
							return error
							});	
							resolve(promiseValue)	         	
						});
					return promiseValues
				}
				else{	
					( async () => { 
						await this.resetGlobal({state: 'indexData'}) 
					})()					
					return true
				}		
			}
			else{
				this.saveNotify(true,'No puedes modificar el javascript de la aplicación')
			}			 
		},
	},
}